import type { CSSProperties } from 'react';

interface Props {
  /** Высота skeleton (px или CSS-значение). */
  height?: number | string;
  /** Ширина (px, % или CSS-значение). По умолчанию full. */
  width?: number | string;
  /** Borderradius (px). По умолчанию 6. */
  radius?: number;
  /** Дополнительный inline-style. */
  style?: CSSProperties;
  /** Сколько skeleton-блоков поставить вертикально (с gap). */
  count?: number;
}

/**
 * Skeleton-плейсхолдер с shimmer-анимацией (для состояния Loading из
 * STATES.md). Не использует JS таймеров — pure CSS animation.
 *
 * Ключевая инвариант: занимает столько же места сколько займут реальные
 * данные → не дёргает layout при загрузке (CLS=0 для поддерживаемых блоков).
 */
export function Skel({ height = 16, width = '100%', radius = 6, style, count = 1 }: Props) {
  const items = Array.from({ length: count });
  return (
    <>
      {items.map((_, i) => (
        <div
          key={i}
          aria-hidden="true"
          className="pcp-skel"
          style={{
            display: 'block',
            height,
            width,
            borderRadius: radius,
            background:
              'linear-gradient(90deg, var(--border, #e6e2d6) 0%, #f3f0e6 50%, var(--border, #e6e2d6) 100%)',
            backgroundSize: '200% 100%',
            animation: 'pcp-skel-shimmer 1.4s linear infinite',
            marginBottom: count > 1 && i < items.length - 1 ? 8 : 0,
            ...style,
          }}
        />
      ))}
      <style>
        {`@keyframes pcp-skel-shimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }`}
      </style>
    </>
  );
}
